import { ca } from '@cian/analytics';

import { type TFilter } from '@/packages/Filters/shared/types/filters';

export function trackFilterOpen(filter: TFilter): void {
  switch (filter) {
    case 'advancedFilters':
      return trackAdvancedFiltersOpen();
  }
}

function trackAdvancedFiltersOpen(): void {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'popup_more_param_open',
  });
}
